.entity-attributes .form-field{width:90%}.entity-attributes .section-name{font-weight:500}.entity-attributes .section-card{margin-top:20px}
/*# sourceMappingURL=/ba/public/entity-attributes.component.css.map */
